import React, { useState } from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import RouteConstants from '../constants/RouteConstants';
import TaxDocuments from '../screens/TaxDocuments';
import withAuth from '../auth/withAuth';
import useAuthRefresh from '../auth/useAuthRefresh';
import useSessionTimeout from '../auth/useSessionTimeout';
import getLinks from './linking';
import useSessionInactivity from '../auth/useSessionInactivity';

// Create the stack navigator
const Stack = createStackNavigator();

function kebabToTitleCase(kebabCase) {
  return kebabCase
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
const Navigation = (props) => {
  const [currentRoute, setCurrentRoute] = useState(RouteConstants.taxdocuments);
  const {
    accessToken,
    authLogout,
    session,
    refreshAuthSession,
    refreshAuthToken,
  } = props; 

  // Calculate the exiry time of the token.
  const TOKEN_EXPIRY_RELATIVE_TIME_IN_MINUTES =
    Math.floor(
      (+new Date(accessToken?.expiresAt * 1000) - Date.now()) / (1000 * 60),
    ) || 13;


  useAuthRefresh(TOKEN_EXPIRY_RELATIVE_TIME_IN_MINUTES);
  useSessionTimeout(TOKEN_EXPIRY_RELATIVE_TIME_IN_MINUTES, authLogout);

  // After 30 Minutes of inactivity, show the timeout modal. 
  const {TimeoutModal} = useSessionInactivity(
    refreshAuthSession,
    authLogout,
    30,
  );

  // Function to handle state changes in the navigation container
  const onStateChange = (state) => {
    const route = state?.routeNames?.[state?.index];
    if (route && route !== currentRoute) {
      setCurrentRoute(route);
    }
  };
  return (
    <NavigationContainer
    testID="navigation-container"
    onStateChange={onStateChange}
    linking={{
      prefixes: ['localhost:8080', '127.0.0.1:8080'],
      config: {
        screens: getLinks(),
      },
    }}
    documentTitle={{
      formatter: (options, route) =>
        `${
          options?.documentTitle ??
          options?.title ??
          kebabToTitleCase(route?.name)
        } - OneAmerica`,
    }}
   >
      <Stack.Navigator
        screenOptions={{ headerShown: false }}
      >
        <Stack.Screen
          name={RouteConstants.taxdocuments}
          component={TaxDocuments}
        />
      </Stack.Navigator>
      {TimeoutModal}
    </NavigationContainer>
  );
};

export default withAuth(Navigation);

